<div class="welcome-container">
    <h1>Access denied</h1>
    @if (signedIn) {
    <p>You are signed in as {{ username }} with role ({{userroles}}) and do not have access to this restricted area.</p>
    } @else {
    <p>You do not have access to this restricted area.</p>
    }

</div>